<template>
    <div :class="{'maxHeight': stateIsValid}">
      <Message
        v-if="conversationState === 'NO_CONNECTION'"
        :message="{ msgLabelKey: 'errors_connection_failed' }"
        :type="'CHAT'"
        :isIncoming="true"/>
      <Message
        v-if="conversationState === 'SESSION_LOST'"
        :message="{ msgLabelKey: 'errors_connection_failed' }"
        :type="'CHAT'"
        :isIncoming="true"/>
      <Message
        v-if="conversationState === 'OUTSIDE_SERVICE_HOURS' && !isUserAuthenticated && !isAiaiBotActive"
        :message="{ msgText: outsideBusinessHoursMsg }"
        :type="'CHAT'"
        :isIncoming="true"/>
      <Message
        v-if="conversationState === 'NO_AGENT_AVAILABLE' && !isUserAuthenticated && !isAiaiBotActive"
        :message="{ msgLabelKey: noAgentMsg }"
        :type="'CHAT'"
        :isIncoming="true"/>
      <Message
        v-if="conversationState === 'AGENT_AVAILABLE_TIMEOUT'"
        :message="{ msgLabelKey: noAgentMsg }"
        :type="'CHAT'"
        :isIncoming="true"/>
    </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Message from './Message'
  import { trigger, triggerType } from '@/helpers/Tracker'
  import { useI36n } from '@jota-one/i36n/src/index.vue2'

  export default {
    components: {
      Message
    },
    name: 'ErrorMessages',
    setup () {
      const { $label: t } = useI36n()
      return { t }
    },
    computed: {
      ...mapState('uistate', [
        'conversationState',
        'outsideServiceHoursMessage',
        'outsideServiceHoursDueToHoliday'
      ]),
      ...mapGetters('uistate', [
        'isCustomerFlow',
        'isAiaiBotActive'
      ]),
      ...mapGetters('conversation', ['isUserAuthenticated']),
      
      stateIsValid () {
        const errors = ['NO_CONNECTION', 'SESSION_LOST', 'AGENT_AVAILABLE_TIMEOUT']
        if (this.isUserAuthenticated) {
          return errors.indexOf(this.conversationState) > -1
        }
        return ['OUTSIDE_SERVICE_HOURS', 'NO_AGENT_AVAILABLE', ...errors].indexOf(this.conversationState) > -1
      },

      outsideBusinessHoursMsg () {
        if (this.outsideServiceHoursDueToHoliday) {
          return this.outsideServiceHoursMessage
        }

        return this.outsideServiceHoursMessage
      },

      noAgentMsg () {
        return this.isCustomerFlow
          ? 'welcome_message'
          : 'no_agent_available'
      }
    },
    watch: {
      conversationState (state) {
        switch (state) {
          case 'OUTSIDE_SERVICE_HOURS': {
            trigger(triggerType.ACTION, 'ChatOutOfOfficeMsgShown')
            break
          }
          case 'NO_AGENT_AVAILABLE': {
            trigger(triggerType.ACTION, 'ChatNoAgentAvailableMsgShown')
            break
          }
          case 'NO_CONNECTION': {
            trigger(triggerType.ACTION, 'ChatSystemUnavailableMsgShown')
            break
          }
        }
      }
    }
  }
</script>

<style scoped lang="postcss">
.maxHeight {
  width: 100%;
}
</style>
